// extracted by mini-css-extract-plugin
export default {"container":"PercentInput_container__OP+NK","label":"PercentInput_label__mBCIO","percent":"PercentInput_percent__prLv9","description":"PercentInput_description__sHyfr"};